import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Paper, TextField, Typography } from "@mui/material";
import { AppColor } from "../../../../types/Constants";


interface CreateGroupProps {
    onClose: (name: string | null, identifier: string | null) => void,
    isLoading: boolean
}

const CreateGroup: React.FC<CreateGroupProps> = ({ onClose, isLoading }) => {

    const [newExperienceInput, setNewExperienceInput] = useState<string>("");
    const [newIdentifierInput, setNewIdentifierInput] = useState<string>("");

    const handleValueEdited = (event: any) => {
        setNewExperienceInput(event.target.value);
    };
    
    const handleEnterText = () => {
        onClose(newExperienceInput, newIdentifierInput);
    };

    const handleCancelPressed = () => {
        onClose(null, null);
    };

    const isFormChange = () => {
        return (
            newExperienceInput !== "" &&
            newIdentifierInput !== ""
        );
    };

    return (
        <Paper sx={{ m: 1, backgroundColor: "white", maxWidth: "600px" }} elevation={1}>
            <Box sx={{ padding: 4 }}>
            <Typography variant="h6">Create a New Experience</Typography>
            {isLoading ? (
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: 120 }}>
                <CircularProgress />
                </Box>
            ) : (
            <>
                <TextField
                    autoFocus
                    margin="dense"
                    id="value"
                    value={newExperienceInput}
                    label="Experience"
                    onChange={handleValueEdited}
                    type="text"
                    fullWidth
                    variant="standard"
                    autoComplete=""
                    aria-autocomplete="none"
                />
                <TextField
                    margin="dense"
                    id="value"
                    value={newIdentifierInput}
                    label="Identifier"
                    onChange={(e) => setNewIdentifierInput(e.target.value)}
                    type="text"
                    helperText="Lowercase letters (a-z) and numbers (0-9) only. No spaces or special characters."
                    fullWidth
                    variant="standard"
                />
            </>
            )}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography>Group URL: ar.skidattl.com/{newIdentifierInput}</Typography>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2, gap: 2 }}>
                        <Button onClick={handleCancelPressed} sx={{color: "#FC7535", backgroundColor: AppColor.orangeBackground, padding: "0px 20px"}}>{"Cancel"}</Button>
                        <Button variant="contained" onClick={handleEnterText} sx={{ padding: "6px 20px" }} disabled={!isFormChange()}>{"Create"}</Button>
                    </Box>
                </Box>
            </Box>
        </Paper>
    );
};

export default CreateGroup;